<div class="palmyra-dialog">
 
  <button class="close-btn" (click)="close()" aria-label="Close dialog">×</button>

  <div class="header">
    <img src="assets/logos/x5-baby.png" alt="Palmyra X5 Logo" class="logo" />

    <h2>Palmyra X5</h2>
    <div class="sub">
      1M Context • Enterprise Agents • Structured Automation
    </div>
  </div>

  <div class="body">
    <p>
      <strong>Palmyra X5</strong> is Writer’s flagship enterprise language model engineered for
      <strong>long-context reasoning</strong>, <strong>multi-step planning</strong>, and
      <strong>tool-enabled agent workflows</strong>.
      <br /><br />
      Unlike lightweight chat-focused models, X5 is designed for environments where the AI must
      ingest large volumes of structured and unstructured data, maintain consistency across
      long conversations, and execute tasks reliably inside real business systems.
    </p>

    <p>
      It excels in scenarios where the model must:
      read entire policy libraries, compare large documents, extract structured data,
      generate compliant outputs, call APIs, and orchestrate workflows — all while
      maintaining stability and predictable formatting.
    </p>

    <ul>
      <li>
        🧠 <strong>1M-Token Context Window:</strong>
        Designed to process extremely large inputs — contracts, compliance manuals,
        research corpora, multi-thread transcripts, knowledge bases, and system logs —
        without losing coherence.
      </li>

      <li>
        🛠️ <strong>Agent-Optimized Tool Use:</strong>
        Built for structured tool-calling, delegation, and multi-step execution.
        Ideal for AI agents that must search → reason → act → validate → summarize.
      </li>

      <li>
        📊 <strong>Structured Output Discipline:</strong>
        Strong at producing stable schemas (JSON, tables, extraction formats),
        making it suitable for downstream automation and system-to-system integrations.
      </li>

      <li>
        ⚡ <strong>Enterprise Throughput + Efficiency:</strong>
        Tuned for large-scale deployment — balancing speed, cost control,
        and high reliability under production workloads.
      </li>

      <li>
        🏢 <strong>Business-Grade Alignment:</strong>
        Designed for professional tone, consistency, and guardrail adherence.
        Particularly useful for compliance-heavy or policy-sensitive environments.
      </li>

      <li>
        ☁️ <strong>Flexible Deployment Options:</strong>
        Available through Writer’s platform and supported within managed
        environments like Amazon Bedrock for enterprise infrastructure alignment.
      </li>
    </ul>

    <div class="optimal">
      <h3>When is Palmyra X5 optimal?</h3>
      <ul>
        <li>When you need extremely long context (hundreds of pages, multi-source ingestion, large conversations)</li>
        <li>For AI agents that must reason, call tools, and execute multi-step workflows reliably</li>
        <li>For enterprise automation: document extraction, compliance review, workflow routing, and validation</li>
        <li>When consistent formatting and schema adherence are critical</li>
        <li>For knowledge-heavy operations such as legal, finance, policy, or internal documentation systems</li>
      </ul>
    </div>

    <div class="optimal">
      <h3>Where Palmyra X5 shines</h3>
      <ul>
        <li>📄 Large-scale document comparison and synthesis</li>
        <li>🧾 Structured data extraction from contracts and policies</li>
        <li>🤖 Agent-based workflows across enterprise systems</li>
        <li>📚 Knowledge base copilots for internal teams</li>
        <li>⚙️ Automated business processes requiring reliable tool-calling</li>
      </ul>
    </div>

    <p>
      In short, <strong>Palmyra X5</strong> is built for organizations that need more than chat —
      it is optimized for scalable reasoning, structured execution, and dependable
      enterprise automation across large, complex information environments.
    </p>
  </div>
</div>
